module.exports = __webpack_public_path__ + "img/Group_22_rotated.bfa46da3.png";